import { render } from "./Comp1.vue?vue&type=template&id=461b0e5c&scoped=true&ts=true"
import script from "./Comp1.vue?vue&type=script&lang=ts"
export * from "./Comp1.vue?vue&type=script&lang=ts"

import "./Comp1.vue?vue&type=style&index=0&id=461b0e5c&lang=css&scoped=true"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461b0e5c"]])

export default __exports__